import avatar from "../../assets/images/avatar.png";
export const languagesHeaders = [
  {
    headerName: "User Name",
    headerId: "firstName",
  },
  {
    headerName: "User ID",
    headerId: "twgId",
  },
];

export const languagesData = [
  {
    userName: "Arvind",
    about: "We become what we think ab...",
    lastLogin: "23-02-2023",
  },
  {
    userName: "John Suresh",
    about: "We become what we think ab...",
    lastLogin: "23-02-2023",
  },
  {
    userName: "George",
    about: "We become what we think ab...",
    lastLogin: "23-02-2023",
  },
  {
    userName: "Stephen Gill",
    about: "We become what we think ab...",
    lastLogin: "23-02-2023",
  },
];
export const allUsersHeaders = [
  {
    headerName: "User Name",
    headerId: "firstName",
    image: true,
  },
  {
    headerName: "Email",
    headerId: "email",
  },
  {
    headerName: "Last Activity",
    headerId: "lastActivity",
  },
  {
    headerName: "Language",
    headerId: "language_prefference",
  },
  {
    headerName: "Reset Password",
    headerId: "canResetPassword",
  },
  // {
  //   headerName: "User Status",
  //   headerId: "active",
  // },
  {
    headerName: "Actions",
    headerId: "actions",
  },
];
export const allUsersData = [
  {
    userName: {
      imgUrl: avatar,
      name: "Glenn Maxwell",
    },
    userId: "#099129",
    lastActivity: "14/03/2023 09:18PM",
    language: "English",
    status: "Active",
  },
  {
    userName: {
      imgUrl: "",
      name: "Glenn Maxwell",
    },
    userId: "#099129",
    lastActivity: "14/03/2023 09:18PM",
    language: "English",
    status: "Inactive",
  },
  {
    userName: {
      imgUrl: "",
      name: "Glenn Maxwell",
    },
    userId: "#099129",
    lastActivity: "14/03/2023 09:18PM",
    language: "English",
    status: "Active",
  },
];

// add user const

export const langArray = [
  { value: "tamil", label: "Tamil" },
  { value: "English", label: "English" },
  { value: "Hindi", label: "Hindi" },
];

export const SUPER_ADMIN = "39stc8";
export const CMS_ADMIN = "67hbi5";
export const TESTIMONIAL_ADMIN = "02wqsz1";
export const CURRICULUM_ADMIN = "23yutr7";
export const APP_USER = "49yrj0";
export const CHURCH_ADMIN = "17dwer8";
export const CHURCH_ADMIN_ROLE_NAME = "Church Admin";
export const CHANNEL_ADMIN_ROLE_NAME = "Channel Admin";
export const MINISTRY_ADMIN_ROLE_NAME = "Ministry Admin";
